<nav id="sidebar">
  
  <ul id="sidebar-list" class="list-unstyled components animate__animated animate__faster" [hidden]="isMinimized()">

    <!-- Homepage -->
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/homepage']" (click)="changeTitle('R.A.M. Consulting')"
        routerLinkActive="active" data-toggle="pill" role="tab" aria-controls="v-pills-home" aria-selected="true">
        <p style="margin-bottom: 0 !important;"><i class="fas fa-home"></i> Homepage</p>
      </a>
    </li>

    <!-- 3 livelli -->
    <ng-template ngFor let-item [ngForOf]="ouItems">
      <ng-template [ngIf]="item.title">
        <li class="nav-item">
          <a role="button" class="nav-link dropdown-toggle" data-toggle="collapse" aria-expanded="false"
            [ngClass]="item.isOpen ? '' : 'collapsed'" (click)="changeUoDropDownState(item.index)">
            <span class="nav-item-text">{{item.title | translate}}</span>
          </a>
          <div class="collapse" aria-expanded="false" [ngClass]="item.isOpen ? 'show' : ''">
            <ul class="list-unstyled">
              <ng-template ngFor let-section [ngForOf]="item.sections">
                <li class="nav-item">
                  <a role="button" class="nav-link dropdown-toggle app-dropdown" data-toggle="collapse"
                    aria-expanded="false" [ngClass]="section.isOpen ? '' : 'collapsed'"
                    (click)="changeSectionDropDownState(item.index, section.index)">
                    <span class="nav-item-text">{{section.title | translate}}</span>
                  </a>
                  <div class="collapse" aria-expanded="false" [ngClass]="section.isOpen ? 'show' : ''">
                    <ul class="list-unstyled" *ngFor="let app of section.apps">
                      <a class="nav-link nav-child-link" [routerLink]="['/cambio-obiettivo']" routerLinkActive="active"
                        (click)="changeTitle('Cambio Obiettivo'); !deviceService.isDesktop() ? toggleSidebar() : null;"
                        *ngIf="app.title === 'Cambio Obiettivo'">
                        <span>{{'modelloCambioObiettivo' | translate}}</span>
                      </a>
                      <a class="nav-link nav-child-link" [routerLink]="['/simulativo']" routerLinkActive="active"
                        (click)="changeTitle('Simulativo'); !deviceService.isDesktop() ? toggleSidebar() : null;"
                        *ngIf="app.title === 'Simulativo'">
                        <span>{{'simulativoGestioneCambio' | translate}}</span>
                      </a>
                      <a class="nav-link nav-child-link" [routerLink]="['/pricing-derivati-cambi']" routerLinkActive="active"
                        (click)="changeTitle('Pricing Derivati Cambi'); !deviceService.isDesktop() ? toggleSidebar() : null;"
                        *ngIf="app.title === 'Pricing Derivati Cambi'">
                        <span>{{'pricingDerivatiCambi' | translate}}</span>
                      </a>
                    </ul>
                  </div>
                </li>
              </ng-template>
              <ng-template ngFor let-app [ngForOf]="item.apps">
                <li class="nav-item" *ngIf="app.appId">
                  <a role="button" class="nav-link dropdown-toggle app-dropdown" data-toggle="collapse"
                    aria-expanded="false" [ngClass]="app.isOpen ? '' : 'collapsed'"
                    (click)="changeAppDropDownState(item.index, app.index)">
                    <span class="nav-item-text">{{app.title | translate}}</span>
                  </a>
                  <div class="collapse" aria-expanded="false" [ngClass]="app.isOpen ? 'show' : ''">
                    <ul class="list-unstyled">
                      <ng-template ngFor let-sheet [ngForOf]="app.sheets">
                        <li class="nav-item">
                          <a [ngClass]="sheet.active === true ? 'nav-link active' : 'nav-link nav-child-link'"
                            routerLinkActive="active" (click)="navigate(sheet, app); !deviceService.isDesktop() ? toggleSidebar() : null;">
                            <i class="{{sheet.icon}}"></i>&nbsp;
                            <span>{{sheet.title | translate}}</span>
                          </a>
                        </li>
                      </ng-template>
                      <ng-template ngFor let-group [ngForOf]="app.groups">
                        <li class="nav-item">
                          <a role="button" class="nav-link dropdown-toggle group-dropdown" data-toggle="collapse"
                            aria-expanded="false" [ngClass]="group.isOpen ? '' : 'collapsed'"
                            (click)="changeGroupDropDownState(item.index, app.index, group.index)">
                            <span class="nav-item-text">{{group.title | translate}}</span>
                          </a>
                          <div class="collapse" aria-expanded="false" [ngClass]="group.isOpen ? 'show' : ''">
                            <ul class="list-unstyled">
                              <ng-template ngFor let-sheet [ngForOf]="group.sheets">
                                <li class="nav-item">
                                  <a [ngClass]="sheet.active === true ? 'nav-link active' : 'nav-link group-dropdown'"
                                    routerLinkActive="active" (click)="navigate(sheet, app); !deviceService.isDesktop() ? toggleSidebar() : null;">
                                    <i class="{{sheet.icon}}"></i>&nbsp;
                                    <span>{{sheet.title | translate}}</span>
                                  </a>
                                </li>
                              </ng-template>
                            </ul>
                          </div>
                        </li>
                      </ng-template>
                    </ul>
                  </div>
                </li>
                <li class="nav-item" *ngIf="!app.appId && app.title === 'Amministrazione'">
                  <a class="nav-link nav-child-link" [routerLink]="['/gestione-utenti']" routerLinkActive="active"
                    (click)="changeTitle('Amministrazione'); !deviceService.isDesktop() ? toggleSidebar() : null;">
                    <span>{{'gestioneUtenti' | translate}}</span>
                  </a>
                </li>
                <li class="nav-item" *ngIf="!app.appId && app.title === 'Amministrazione'">
                  <a class="nav-link nav-child-link" [routerLink]="['/gestione-gruppi']" routerLinkActive="active"
                    (click)="changeTitle('Amministrazione'); !deviceService.isDesktop() ? toggleSidebar() : null;">
                    <span>{{'gestioneGruppi' | translate}}</span>
                  </a>
                </li>
                <li class="nav-item" *ngIf="!app.appId && app.title === 'Amministrazione'">
                  <a class="nav-link nav-child-link" [routerLink]="['/upload-modelli']" routerLinkActive="active"
                    (click)="changeTitle('Amministrazione'); !deviceService.isDesktop() ? toggleSidebar() : null;">
                    <span>{{'uploadModelli' | translate}}</span>
                  </a>
                </li>
              </ng-template>
            </ul>
          </div>
        </li>
      </ng-template>
      <ng-template ngFor let-app [ngForOf]="item.apps" *ngIf="!item.title">
        <ng-template [ngIf]="app.title && app.appId">
          <li class="nav-item">
            <a role="button" class="nav-link dropdown-toggle" data-toggle="collapse" aria-expanded="false"
              [ngClass]="app.isOpen ? '' : 'collapsed'" (click)="changeAppDropDownState(item.index, app.index)">
              <span class="nav-item-text">{{app.title | translate}}</span>
            </a>
            <div class="collapse" aria-expanded="false" [ngClass]="app.isOpen ? 'show' : ''">
              <ul class="list-unstyled">
                <ng-template ngFor let-sheet [ngForOf]="app.sheets">
                  <li class="nav-item">
                    <a [ngClass]="sheet.active === true ? 'nav-link active' : 'nav-link nav-child-link'"
                      routerLinkActive="active" (click)="navigate(sheet, app); !deviceService.isDesktop() ? toggleSidebar() : null;">
                      <i class="{{sheet.icon}}"></i>&nbsp;
                      <span>{{sheet.title | translate}}</span>
                    </a>
                  </li>
                </ng-template>
                <ng-template ngFor let-group [ngForOf]="app.groups">
                  <li class="nav-item" *ngIf="app.appId">
                    <a role="button" class="nav-link dropdown-toggle app-dropdown" data-toggle="collapse"
                      aria-expanded="false" [ngClass]="group.isOpen ? '' : 'collapsed'"
                      (click)="changeGroupDropDownState(item.index, app.index, group.index)">
                      <span class="nav-item-text">{{group.title | translate}}</span>
                    </a>
                    <div class="collapse" aria-expanded="false" [ngClass]="group.isOpen ? 'show' : ''">
                      <ul class="list-unstyled">
                        <ng-template ngFor let-sheet [ngForOf]="group.sheets">
                          <li class="nav-item">
                            <a [ngClass]="sheet.active === true ? 'nav-link active' : 'nav-link group-dropdown'"
                              routerLinkActive="active" (click)="navigate(sheet, app); !deviceService.isDesktop() ? toggleSidebar() : null;">
                              <i class="{{sheet.icon}}"></i>&nbsp;
                              <span>{{sheet.title | translate}}</span>
                            </a>
                          </li>
                        </ng-template>
                      </ul>
                    </div>
                  </li>
                </ng-template>
              </ul>
            </div>
          </li>
        </ng-template>
        <ng-template [ngIf]="app.title && !app.appId">
          <li class="nav-item" *ngIf="app.title === 'Download Modelli'">
            <a role="button" class="nav-link dropdown-toggle" data-toggle="collapse" aria-expanded="false"
              [ngClass]="app.isOpen ? '' : 'collapsed'" (click)="changeAppDropDownState(item.index, app.index)">
              <span class="nav-item-text">{{'corporateTreasury' | translate}}</span>
            </a>
            <div class="collapse" aria-expanded="false" [ngClass]="app.isOpen ? 'show' : ''">
              <ul class="list-unstyled">
                <a class="nav-link nav-child-link" [routerLink]="['/marketplace']"
                  routerLinkActive="active"
                  (click)="changeTitle('Download Modelli'); !deviceService.isDesktop() ? toggleSidebar() : null;">
                  <span>{{'marketplace' | translate}}</span>
                </a>
              </ul>
            </div>
          </li>
        </ng-template>
      </ng-template>
    </ng-template>

    <!-- Tutorial -->
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/tutorial']" (click)="changeTitle('Tutorial')"
        routerLinkActive="active" data-toggle="pill" role="tab" aria-controls="v-pills-home" aria-selected="true">
        <p style="margin-bottom: 0 !important;">{{'tutorial'|translate}}</p>
      </a>
    </li>

    <!-- Richiedi Assistenza -->
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/richiesta-assistenza']" (click)="changeTitle('Richiedi Assistenza')"
        routerLinkActive="active" data-toggle="pill" role="tab" aria-controls="v-pills-home" aria-selected="true">
        <p style="margin-bottom: 0 !important;">{{'richiediAssistenza'|translate}}</p>
      </a>
    </li>

  </ul>
</nav>